import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Sparkles, ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import { newLaunchItems } from "@/lib/newLaunch";

const ROTATE_MS = 4000;

export const HeroNewLaunch = () => {
  const [items, setItems] = useState([]);
  const [flagged, setFlagged] = useState(true);
  const [i, setI] = useState(0);

  useEffect(() => {
    api.get("/products")
      .then((res) => {
        const picked = newLaunchItems(res.data);
        setItems(picked.items);
        setFlagged(picked.flagged);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (items.length < 2) return undefined;
    const t = setTimeout(() => setI((n) => (n + 1) % items.length), ROTATE_MS);
    return () => clearTimeout(t);
  }, [i, items.length]);

  if (!items.length) return null;
  const p = items[i % items.length];

  return (
    <motion.a
      href="#new-launch"
      data-testid="hero-new-launch-box"
      initial={{ opacity: 0, x: 24 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 0.6, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="group relative block w-full overflow-hidden rounded-3xl border border-yellow-300/25 bg-[#12141A] p-4 transition-colors hover:border-yellow-300/60 lg:max-w-sm lg:justify-self-end"
    >
      <div className="flex items-center justify-between px-1 pb-3">
        <span className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-yellow-300">
          <Sparkles size={12} /> {flagged ? "New Launch" : "Latest Arrivals"}
        </span>
        <ArrowUpRight size={14} className="text-slate-500 transition-colors group-hover:text-yellow-300" />
      </div>
      <div className="relative aspect-[4/5] overflow-hidden rounded-2xl bg-[#0F1118]">
        <AnimatePresence mode="wait">
          <motion.img
            key={p.id}
            src={p.image || "/placeholder-product.svg"}
            alt={p.name}
            onError={(e) => { e.currentTarget.src = "/placeholder-product.svg"; }}
            initial={{ opacity: 0, scale: 1.05 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            data-testid="hero-new-launch-image"
            className="absolute inset-0 h-full w-full object-cover"
          />
        </AnimatePresence>
      </div>
      {items.length > 1 && (
        <div className="mt-3.5 flex gap-1.5 px-1">
          {items.slice(0, 8).map((it, n) => (
            <span
              key={it.id}
              data-testid={`hero-new-launch-dot-${n}`}
              className={`h-1 rounded-full transition-all duration-300 ${n === i % items.length ? "w-6 bg-yellow-300" : "w-2.5 bg-white/20"}`}
            />
          ))}
        </div>
      )}
    </motion.a>
  );
};
